module.exports = __webpack_public_path__ + "media/sprite.bdb2ab67.mp3";